import { IPrivateEndpointMetadata } from './private-endpoint-metadata';

import { getSqlControls, getReadonlyControl, sqlMIResourceIdFormat, sqlMIResourceIdErrorMessage } from './shared-control-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const sqlMIPrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.Sql/managedInstances',
    connectionSuffix: 'privateEndpoints',
    resourceIdValidator: sqlMIResourceIdFormat,
    groupIdMetadata: {
        managedInstance: {
            linkedServiceType: adfModelTypeMap.azureSqlMI.linkedServiceType,
            groupId: 'managedInstance',
            iconClass: 'svg-i-100x100-azure_sql_db_managed_instance',
            displayName: stringResources.AzureSQLManagedInstance_DisplayText,
            controls: {
                creationControls: getSqlControls(false, true),
                readonlyControls: getReadonlyControl(sqlMIResourceIdFormat, sqlMIResourceIdErrorMessage)
            }
        }
    }
};
